export const types = {
  SET_END_DATE: 'perDiemReport/SET_END_DATE',
  SET_DISTRICT: 'perDiemReport/SET_DISTRICT',
  SET_DEPARTMENT: 'perDiemReort/SET_DEPARTMENT',
};

export const setEndDate = (endDate) => {
  return {
    type: types.SET_END_DATE,
    endDate,
  };
};

export const setDistrict = (district) => {
  return {
    type: types.SET_DISTRICT,
    district,
  };
};

export const setDepartment = (department) => {
  return {
    type: types.SET_DEPARTMENT,
    department,
  };
};
